"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { PhoneCall, ShieldAlert, Clock, ArrowRight } from "lucide-react";
export default function ClaimsAdvocacy247() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  return <section id="247-claims-advocacy" className="dark bg-background text-foreground py-16 md:py-24 lg:py-32 relative border-t border-border overflow-hidden">
      {}
      <div className="absolute left-4 md:left-12 lg:left-20 top-0 bottom-0 w-px bg-border hidden md:block">
        <div className="absolute top-32 -left-[1.5px] w-1 h-1 bg-primary" />
      </div>

      <div className="max-w-[1440px] mx-auto px-4 md:px-12 lg:px-20">
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="lg:col-span-7 flex flex-col justify-center md:pl-8 lg:pl-12">
            <div className="flex items-center gap-4 mb-8">
              <span className="font-mono text-xs font-bold tracking-widest text-muted-foreground uppercase">
                SEC_04
              </span>
              <div className="h-px w-12 bg-border" />
              <span className="font-mono text-xs font-bold tracking-widest text-primary uppercase flex items-center gap-2">
                <Clock className="w-4 h-4" /> 24/7 Support
              </span>
            </div>

            <h2 className="font-serif text-[clamp(2.5rem,6vw,4.5rem)] leading-[1.05] tracking-tight mb-6">
              <span className="text-muted-foreground/20 font-light mr-2 select-none">[</span>
              Immediate Action.
              <br />
              Absolute Certainty.
              <span className="text-muted-foreground/20 font-light ml-2 select-none">]</span>
            </h2>

            <p className="font-sans text-lg md:text-xl text-muted-foreground leading-relaxed max-w-2xl mb-10">
              When the unexpected occurs, Vanguard Shield is your first line of defense. Our dedicated claims advocacy team operates around the clock, ensuring your recovery begins the moment you need us. No delays. No uncertainty.
            </p>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-8">
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 h-14 px-8 text-base font-semibold shadow-sm hover:shadow-md transition-all">
                <Link to="/ClaimsCenterPage">
                  Start a Claim <ArrowRight className="ml-2 w-5 h-5" />
                </Link>
              </Button>
              
              <div className="flex items-center gap-4 text-muted-foreground">
                <div className="w-12 h-12 border border-border flex items-center justify-center bg-card/30">
                  <PhoneCall className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <p className="font-mono text-xs uppercase tracking-widest mb-1 text-muted-foreground">Emergency Line</p>
                  <p className="font-sans font-medium text-foreground text-lg tracking-wide">(217) 555-7890</p>
                </div>
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 relative mt-8 lg:mt-0">
            <div className="border border-border p-8 md:p-12 h-full flex flex-col justify-between relative group bg-card/40 backdrop-blur-sm hover:bg-card/60 transition-colors duration-500">
              {}
              <div className="absolute top-0 left-0 right-0 h-1 bg-primary/20 group-hover:bg-primary transition-colors duration-500" />

              <div className="relative z-10">
                <ShieldAlert className="w-12 h-12 text-primary mb-8 stroke-[1.5px]" />
                <h3 className="font-sans text-2xl font-semibold mb-6 text-foreground">The Vanguard Guarantee</h3>
                <ul className="space-y-5 font-sans text-muted-foreground">
                  <li className="flex items-start gap-4">
                    <div className="mt-2 w-1.5 h-1.5 bg-primary shrink-0" />
                    <span className="leading-relaxed">Immediate incident response and documentation guidance.</span>
                  </li>
                  <li className="flex items-start gap-4">
                    <div className="mt-2 w-1.5 h-1.5 bg-primary shrink-0" />
                    <span className="leading-relaxed">Direct liaison with adjusters to expedite your settlement.</span>
                  </li>
                  <li className="flex items-start gap-4">
                    <div className="mt-2 w-1.5 h-1.5 bg-primary shrink-0" />
                    <span className="leading-relaxed">Transparent, step-by-step updates throughout the process.</span>
                  </li>
                </ul>
              </div>

              <div className="relative z-10 mt-16 pt-8 border-t border-border flex justify-between items-end">
                <div>
                  <p className="font-mono text-xs text-muted-foreground uppercase tracking-widest mb-2">Average Response</p>
                  <p className="font-serif text-4xl text-foreground">&lt; 3 Min</p>
                </div>
                <div className="font-mono text-[10px] text-muted-foreground/40 text-right tracking-widest">
                  39.7817° N<br />89.6501° W
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}